var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1444_2164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 1.25H3.75C2.7558 1.25119 1.80267 1.64666 1.09966 2.34966C0.396661 3.05267 0.00119089 4.0058 0 5L0 14C0.00119089 14.9942 0.396661 15.9473 1.09966 16.6503C1.80267 17.3533 2.7558 17.7488 3.75 17.75H14.25C15.2442 17.7488 16.1973 17.3533 16.9003 16.6503C17.6033 15.9473 17.9988 14.9942 18 14V5C17.9988 4.0058 17.6033 3.05267 16.9003 2.34966C16.1973 1.64666 15.2442 1.25119 14.25 1.25ZM3.75 2.75H14.25C14.6991 2.75088 15.1376 2.88614 15.5092 3.13835C15.8808 3.39057 16.1684 3.74821 16.335 4.16525L10.5915 9.9095C10.1688 10.3305 9.59656 10.5669 9 10.5669C8.40344 10.5669 7.83118 10.3305 7.4085 9.9095L1.665 4.16525C1.83161 3.74821 2.11921 3.39057 2.49079 3.13835C2.86236 2.88614 3.30091 2.75088 3.75 2.75ZM14.25 16.25H3.75C3.15326 16.25 2.58097 16.0129 2.15901 15.591C1.73705 15.169 1.5 14.5967 1.5 14V6.125L6.348 10.97C7.05197 11.6722 8.00569 12.0665 9 12.0665C9.99431 12.0665 10.948 11.6722 11.652 10.97L16.5 6.125V14C16.5 14.5967 16.2629 15.169 15.841 15.591C15.419 16.0129 14.8467 16.25 14.25 16.25Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1444_2164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.72f6471b84276ff39975c144de9aab8f.svg";
export { ForwardRef as ReactComponent };